import { render, staticRenderFns } from "./ReportLowStock.vue?vue&type=template&id=23965532"
import script from "./ReportLowStock.vue?vue&type=script&lang=js"
export * from "./ReportLowStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports